import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = ({ style }) => (
  <path
    style={style}
    d="M47.25,29.93C44.54,40.56,34.97,48,24,48h-1.57l-0.05-0.06L8.19,31.38l-0.84-1L7,30l0.21-0.08l0.53-0.21
l0.79-0.32l0.23-0.1l3.38-1.36l5.09-5.69l5.09-11.55l3.39,2.07l1.59-1.77l7.56,7.77l-0.03,0.03l0.03-0.01h0.06l1.94,1.75
L47.25,29.93z"
  />
);

const KillerBunnyAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.AVATAR_1}
    renderShadow={renderShadow}
  >
    <>
      <path
        style={{ fill: '#FFFFFF' }}
        d="M38.18,32.11H11.24c1-1.72,5.21-8.72,10.69-12.08c7.81-4.8,14.13-2.66,16.61,3.36
	C39.66,26.21,39.53,29.38,38.18,32.11z"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M15,31.56c-0.62,0.23-1.26,0.42-1.91,0.55c-0.3,0.06-0.61,0.1-0.92,0.13h-0.31h-0.4
	c-0.4-0.01-0.79-0.05-1.18-0.11c-0.12-0.01-0.24-0.03-0.36-0.07c-0.06,0.01-0.11,0.01-0.17,0c-0.78-0.2-1.51-0.56-2.14-1.05l0,0l0,0
	c-0.15-0.12-0.29-0.25-0.42-0.39l0,0c-1.73-1.82-0.32-4.79,3.1-7.25c1.22-0.9,2.73-1.31,4.24-1.15c0.15,0.01,0.31,0.04,0.46,0.07
	c0.9,0.15,1.74,0.56,2.42,1.18c0.08,0.07,0.16,0.15,0.23,0.23l0.06,0.07c0.16,0.18,0.3,0.37,0.42,0.58
	C19.36,26.55,18.23,30.31,15,31.56z"
      />
      <circle style={{ fill: '#FFFFFF' }} cx="40.68" cy="29.52" r="2.6" />
      <ellipse
        transform="matrix(0.67 -0.7423 0.7423 0.67 -6.3791 21.3051)"
        style={{ fill: '#FFFFFF' }}
        cx="20.78"
        cy="17.83"
        rx="9.52"
        ry="2.16"
      />
      <ellipse
        transform="matrix(0.4619 -0.8869 0.8869 0.4619 -6.8032 26.1646)"
        style={{ fill: '#FFFFFF' }}
        cx="18.16"
        cy="18.69"
        rx="9.01"
        ry="2.05"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M28.58,32.56c0.6-1.44,2.15-1.94,5-2.21s5.24,0.28,5.33,1.23c0.09,0.95-1.68,1.4-5,2.22
	C31.09,34.49,27.69,34.71,28.58,32.56z"
      />
      <circle style={{ fill: '#333333' }} cx="10.38" cy="26.05" r="0.87" />
      <path
        style={{ fill: '#EF4735' }}
        d="M12.48,30.93c0,0-0.45,0.82-0.35,1.18l0,0c0,0.03,0,0.06,0,0.09l0,0c-0.24,0-0.47,0-0.7,0
	c-0.4-0.01-0.79-0.05-1.18-0.11c-0.12-0.01-0.24-0.03-0.36-0.07c-0.06,0.01-0.11,0.01-0.17,0c-0.76-0.19-1.48-0.53-2.11-1.01l0,0
	l0,0c-0.15-0.12-0.29-0.25-0.42-0.39l0,0c0.38-0.19,0.71-0.45,1-0.76c1.11-1.13,1.11,0,1.11,0s-1.11,1.15,0,1.15s1.09-2.28,2.2-2.28
	s0,1.13,0,1.13s-1.11,1.15,0,1.15s0-1.15,1.1-1.15h0.18C13.46,29.92,12.48,30.93,12.48,30.93z"
      />
      <path
        style={{ fill: '#EF4735' }}
        d="M12.47,31.7L12.47,31.7c0,0,1.23-1.43,1.37-1.32s0.25,0.46-0.26,1C13.22,31.74,12.11,32.11,12.47,31.7z"
      />
      <path
        style={{ fill: '#EF4735' }}
        d="M14,28.53c-0.45,0.26-0.94,0.46-1.44,0.6l0.73-1.12c0.13-0.2,0.4-0.25,0.6-0.12c0.2,0.13,0.25,0.4,0.12,0.6l0,0
	L14,28.53z"
      />
    </>
  </AvatarArtwork>
);

export default KillerBunnyAvatarArtwork;
